module.exports = __webpack_public_path__ + "static/media/time-input.1537d483.svg";